import React from 'react'

export default function FrontAuthCentered (props)
{
	return (
		<div className="u-table u-full-width" style={ { 'minHeight': '100%' } }>
		
			<div className="u-table-row">

				<div className="u-table-cell u-vertical-align-middle">

					<div className="o-grid">

						<div className="o-grid__item-12 u-text-center">
							{ props.children }
						</div>

					</div>

				</div>

			</div>

		</div>
	);
}